import { createFileRoute } from '@tanstack/react-router';
import NotFoundPage from '@/pages/not-found.page';

export const Route = createFileRoute('/design-studio-embed/cio/$')({
  component: NotFoundPage,
});
